import { withInstall } from '@tav-ui/utils/with-install'
import CollapseTransition from './src/CollapseTransition.vue'

const TaCollapseTransition = withInstall(CollapseTransition)

export { TaCollapseTransition }
export default TaCollapseTransition
